module.exports = __webpack_public_path__ + "img/farming_20.8ccf60b1.png";